import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import PublicationTitle from 'hb-react/shared/components/Publication/PublicationTitle';

const NewsTitle = ({ title, publishedAt, sharingUrl, socialMediaList }) => (
  <WrapperStyled>
    <PublicationTitle
      title={title}
      titleAs="h1"
      publishedAt={publishedAt}
      socialMediaList={socialMediaList}
      sharingUrl={sharingUrl}
      shareAmplitudeEvent="News|NewsShared"
      shareButtonLabel={__('Share news')}
    />
  </WrapperStyled>
);

export default NewsTitle;

const WrapperStyled = styled(Box).attrs({
  display: 'block',
  mb: 3,
  mr: { m: -2, l: -2, xl: -3 },
})``;
